import unauthBase from "unauth_base";

Promise.all([import("cookie-helper"), import("url-helper")]).then(deps => {
    let [cookie, url] = deps;

    var params = url.getQueryParams();
    if (params.via) {
        cookie.set("tap_via", params.via, 30);
    }
});
